import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IUserSchemaPartial } from '../../type/user';

export interface IUpdateUserSettingMutationFields {
  _id: string;
  companyId?: string;
  language?: string;
  country?: string;
  currency?: string;
}


export interface IUpdateUserSettingMutationResponseFields {
  updatedUser: IUserSchemaPartial;
}



export function updateUserSettingMutation(fragment: string): DocumentNode {
  return gql`
        mutation updateUserSetting (
        $_id: String!,
$companyId: String,
$language: String,
$country: String,
$currency: String
        ) {
        updateUserSetting (
        _id: $_id,
companyId: $companyId,
language: $language,
country: $country,
currency: $currency
        ) {
        ...fragment
        }
        }
        fragment fragment on UpdateUserSettingMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUpdateUserSettingMutation<TData extends Partial<IUpdateUserSettingMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ updateUserSetting: TData },
        IUpdateUserSettingMutationFields>,
) {
  return useMutation<{ updateUserSetting: TData },
      IUpdateUserSettingMutationFields>(
        updateUserSettingMutation(fragment), options,
      );
}
